export const QueryLabels = {
  dateRange: 'Date From/To:',
  locations: 'Locations:',
  trackingMethods: 'Tracking Methods:',
  groupBy: 'Pivot On:',
  sumOrCountBy: 'Sum/Count By:',
  reportType: 'Report Type:',
  firstTimeBy: 'First Time By:',
  reportAs: 'Show Result for:',
  resultBy: 'Result By:'
};

export const CustomColumnLabel = {
  visit_count: '# of HH Visits',
  household_total_group: 'Total Individuals Group',
  household_total_sum: 'Total Individuals Sum',
  trackResult_household: 'Track Result # in HH',
  location_id_group: 'Location Group',
  trackMethod_id_group: 'Tracking Method Group',
  outreach_id_group: 'Outreach Group'
};
